import { translate as t } from "../../../../../infrastructure/translate/localization";
import BenefitCard from "../../BenefitCard";
import { CountryIsoCode } from "../../../../../v2/domain/common/enums/CountryISOCode";
import retirementInsuranceBenefitImageV2 from "../../../../../assets/img/v2/retirement-insurance-benefit.png";
import retirementInsuranceBenefitDisabledImageV2 from "../../../../../assets/img/v2/retirement-insurance-benefit-disabled.png";

const RetirementInsuranceTab = ({
  selectedTab,
  country,
}: {
  selectedTab: {
    id: string;
    allowedBenefits: string[];
    retirementInsuranceProductConfig: {
      enabled: boolean;
    };
    retirementInsuranceBenefit: boolean;
  };
  country: CountryIsoCode;
}) => {
  return (
    <BenefitCard
      title={t("benefits-section.retirement-benefit.retirement")}
      active={
        selectedTab?.retirementInsuranceProductConfig?.enabled &&
        selectedTab.allowedBenefits.includes("retirement-insurance-benefit")
      }
      image={
        selectedTab.retirementInsuranceBenefit
          ? retirementInsuranceBenefitImageV2
          : retirementInsuranceBenefitDisabledImageV2
      }
      country={country}
      hasV2Screen
      handleSeeMore={() =>
        window.location.assign(
          `/v2/benefits/compensation-plan/${selectedTab.id}/retirement-insurance?tab=information`
        )
      }
    />
  );
};

export default RetirementInsuranceTab;
